module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Sea-Import Consolidation Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "conBooking"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Assignment")]), _vm._v(" "), _c('th', [_vm._v("More Details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.conSeaImportData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewExportAirPage(item1.conSeaImportId, item1.statusFinal)
        }
      }
    }, [_c('b', [_vm._v("Assignment No. :")]), _vm._v("\n                  " + _vm._s(item1.conSeaImportSeries) + "\n                  (\n                  "), _c('b', [_vm._v(_vm._s(item1.containerInfo == "FclConsolidation" ?
      "FCL-Conso" :
      "LCL-Conso"))]), _vm._v(")\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Importer :")]), _vm._v("\n                  " + _vm._s(item1.importer) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Exporter :")]), _vm._v("\n                  " + _vm._s(item1.exporter) + "\n                ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Shipping Line :")]), _vm._v("\n                  " + _vm._s(item1.shippingLine) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Place of Receipt :")]), _vm._v("\n                  " + _vm._s(item1.valPOR) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Load Port Name :")]), _vm._v("\n                  " + _vm._s(item1.valLP) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Cargo Destuffing Location :")]), _vm._v("\n                  " + _vm._s(item1.cargoDeLoca) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Port Of Discharge :")]), _vm._v("\n                  " + _vm._s(item1.valPodLocation) + "\n                ")])])
  }))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06246934","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/clientDashboard/clientSeaImpConso.vue
// module id = 2365
// module chunks = 0